import { combineReducers } from 'redux';
import pinTransferMappedReducer from './pin-transfer-search/reducer/pinTransferMappedReducer';

export const pinTransferCombineReducer = () => combineReducers({
    pinSearch: pinTransferMappedReducer,

});
